export default s => (s || '').replace(/\b\w/g, m => m.toUpperCase());
